export const getLanguage = (state) => state.language.current
export const getLang = (state) => state.language.current.lang
export const getLocale = (state) => state.language.current.locale
export const getPossibilities = (state) => state.language.possibilities
